<template>
  <v-container id="functionalities">
    <!-- <v-card> -->
    <v-card-title class="text-h4 pa-3 text-center font-weight-bold">
      Potencia Tu Negocio con las Funcionalidades de Truster Cloud
    </v-card-title>
    <v-card-title class="text-center text-h6 text-primary">
      Descubre las herramientas clave que automatizan, simplifican y optimizan
      cada proceso para que tu negocio crezca sin límites.
    </v-card-title>
    <v-row
      ref="container"
      class="py-6 py-md-10 py-lg-16 mb-16"
      v-for="(insight, idx) in insights"
      :key="idx"
    >
      <v-col
        cols="12"
        md="6"
        class=""
        :class="{
          'order-1': idx % 2 === 1 && !smAndDown,
          'order-2': idx % 2 === 0 && !smAndDown,
        }"
      >
        <v-card-title class="text-h5 text-primary">
          {{ insight.title }}</v-card-title
        >
        <v-card-text class="text-h6 text-secondary-emphasis">
          {{ insight.description }}</v-card-text
        >
        <v-divider></v-divider>
        <v-card rounded="xl" class="my-4 pa-4 glass-card" width="100%">
          <v-row no-gutters>
            <v-col
              cols="12"
              sm="6"
              md="12"
              lg="6"
              v-for="(insightItem, i) in insight.insights"
              :key="i"
            >
              <v-list-item density="compact" class="pl-0">
                <v-list-item-title
                  class="text-h6 text-wrap"
                >
                  {{ insightItem }}
                </v-list-item-title>
                <template #prepend>
                  <v-icon color="primary" icon="$mdiCheckDecagram"></v-icon>
                </template>
              </v-list-item>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        md="6"
        class=""
        :class="{ 'order-2': idx % 2 === 1, 'order-1': idx % 2 === 0 }"
      >
        <!-- * Formato de imágenes solo para los índices impares -->
        <div class="position-relative w-sm-75 w-md-100 mx-auto">
          <template v-if="(idx + 1) % 2 === 1">
            <NuxtImg
              width="100%"
              :src="insight.images[0].src"
              :sizes="insight.images[0].sizes"
              class="w-100 rounded-xl"
              loading="lazy"
              alt=""
            />
            <NuxtImg
              alt=""
              loading="lazy"
              v-if="insight.images[1]"
              :src="insight.images[1].src"
              :sizes="insight.images[1].sizes"
              class="position-absolute rounded-xl bouncing--vertical"
              :style="{ bottom: '-50px', left: mdAndDown ? '0px' : '-50px' }"
            />
          </template>
          <!-- * Formato de imágenes solo para los índices pares -->
          <template v-if="(idx + 1) % 2 === 0">
            <NuxtImg
              alt=""
              loading="lazy"
              width="100%"
              :src="insight.images[0].src"
              :sizes="insight.images[0].sizes"
              class="w-100 rounded-xl"
            />
            <NuxtImg
              alt=""
              loading="lazy"
              v-if="insight.images[1]"
              :src="insight.images[1].src"
              :sizes="insight.images[1].sizes"
              class="position-absolute rounded-xl bouncing--vertical"
              :style="{
                bottom: '-50px',
                right: mdAndDown ? '12px' : '-50px',
              }"
            />
            <NuxtImg
              alt=""
              loading="lazy"
              v-if="insight.images[2]"
              :src="insight.images[2].src"
              :sizes="insight.images[2].sizes"
              class="position-absolute top-0 right-0 rounded-xl bouncing--horizontal"
              :style="{
                bottom: '-50px',
                right: mdAndDown ? '12px' : '-50px',
              }"
            />
          </template>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup lang="js">
import { useDisplay } from "vuetify";
// import { ref, onMounted, onUnmounted } from 'vue'
const { smAndDown, mdAndDown } = useDisplay();
// import { gsap } from 'gsap'
// import { ScrollTrigger } from 'gsap/ScrollTrigger'

// gsap.registerPlugin(ScrollTrigger)

// const container = ref(null)
// let gsapContext = null

// onMounted(() => {
// 	// Esperamos a que Vuetify y el DOM estén listos
// 	nextTick(() => {
// 		// El contexto se aplica al contenedor principal (<v-row>)
// 		gsapContext = gsap.context(() => {
// 			// Buscamos todas las tarjetas que necesitan ser animadas
// 			const cards = gsap.utils.toArray('.card-anim')

// 			// 3. NUEVA LÓGICA DE ANIMACIÓN
// 			// Creamos una animación para CADA tarjeta, en lugar de una sola timeline
// 			cards.forEach((card) => {
// 				gsap.fromTo(
// 					card,
// 					{
// 						opacity: 0,
// 						x: 100 // Empieza desde la derecha
// 					},
// 					{
// 						opacity: 1,
// 						x: 0,
// 						ease: 'power2.out',
// 						// El ScrollTrigger se configura para cada tarjeta individualmente
// 						scrollTrigger: {
// 							trigger: card, // El trigger es la propia tarjeta
// 							start: 'top 80%', // La animación empieza cuando el 80% de la tarjeta es visible
// 							end: 'bottom 20%', // (Opcional) puedes definir un final
// 							toggleActions: 'play none none reverse' // Anima al entrar, revierte al salir
// 							// markers: true, // Descomenta para depurar una tarjeta específica
// 						}
// 					}
// 				)
// 			})
// 		}, container.value)
// 	})
// })

// onUnmounted(() => {
// 	if (gsapContext) {
// 		gsapContext.revert()
// 	}
// })

// Tus datos de 'insights' permanecen igual
const insights = [
  {
    title: "Escalabilidad Inteligente",
    description:
      "Tu negocio crece, nuestra plataforma se adapta automáticamente. Paga solo por los recursos que utilizas y olvídate de la infraestructura. Así, tu enfoque es el crecimiento a través de la tecnología.",
    images: [
      {
        src: "/assets/home/feature1.webp",
        sizes: "95vw sm:400px md:500px lg:600px xl:800px",
      },
      // {
      //   src: "/assets/home/feature1-floating.webp",
      //   sizes: "150px sm:200px md:250px lg:250px",
      // },
    ],
    insights: [
      "Crecimiento Estratégico",
      "Recursos Dinámicos",
      "Modelo Pago-por-Uso",
      "Automatización Inteligente",
    ],
  },
  {
    title: "Soporte que Impulsa tu Éxito",
    description:
      "Te acompañamos en cada paso. Nuestro equipo no solo te brinda soporte técnico, sino que se convierte en un socio estratégico para asegurar que saques el máximo provecho de cada funcionalidad y alcances tus metas.",
    images: [
      {
        src: "/assets/home/feature2.webp",
        sizes: "95vw sm:400px md:500px lg:600px xl:800px",
      },
      //{
      // src: "/assets/home/feature2-floating.webp",
      //sizes: "200px sm:300px md:250px lg:300px",
      // },
    ],
    insights: [
      "Asesoramiento Estratégico",
      "Soporte Personalizado",
      "Partners en Crecimiento",
    ],
  },
  {
    title: "Rendimiento Superior Garantizado",
    description:
      "La velocidad y la estabilidad son nuestra prioridad. Con una infraestructura de élite y un 99.9% de 'uptime', tu negocio opera sin interrupciones. Cada proceso, desde ventas hasta logística, es rápido y eficiente.",
    images: [
      {
        src: "/assets/home/feature3.webp",
        sizes: "95vw sm:400px md:500px lg:600px xl:800px",
      },
      // {
      //   src: "/assets/home/feature3-floating.webp",
      //   sizes: "200px sm:300px md:250px lg:300px",
      // },
      // {
      //   src: "/assets/home/feature3-floating2.webp",
      //   sizes: "150px sm:250px md:300px lg:300px",
      // },
    ],
    insights: [
      "Velocidad de Alto Nivel",
      "Alta Disponibilidad (99.9%)",
      "Flujo Operativo Continuo",
    ],
  },
  {
    title: "Tu Información, Totalmente Segura.",
    description:
      "Protegemos lo más valioso de tu negocio: tus datos. Utilizamos encriptación avanzada y una vigilancia proactiva 24/7 para garantizar que tu información esté siempre segura y disponible. Tu tranquilidad es nuestra principal responsabilidad.",
    images: [
      {
        src: "/assets/home/feature4.webp",
        sizes: "95vw sm:400px md:500px lg:600px xl:800px",
      },
      //  {
      //    src: "/assets/home/feature3-floating.webp",
      //    sizes: "200px sm:300px md:250px lg:300px",
      //  },
      //  {
      //    src: "/assets/home/feature3-floating2.webp",
      //    sizes: "150px sm:200px md:200px lg:250px",
      //  },
    ],
    insights: [
      "Encriptación Avanzada",
      "Monitoreo 24/7",
      "Auditoría de Seguridad",
    ],
  },
];
</script>

<style lang="scss" scoped>
/* 4. ESTILOS PARA LA COLUMNA PEGAJOSA (STICKY) */

.sticky-column {
  position: sticky;
  /* 'top' define a qué distancia del borde superior se "pegará" la columna.
     Ajusta este valor según la altura de tu barra de navegación (AppBar) */
  top: 100px;
  flex-direction: column;
  align-self: flex-start; /* MUY IMPORTANTE para que sticky funcione en un contenedor flex (v-row) */
}

.sticky-content {
  display: flex;
  flex-direction: column; /* Permite apilar título y subtítulo */
  justify-content: center; /* Centra verticalmente */
  align-items: flex-start; /* Alinea a la izquierda para textos largos */
  height: calc(100vh - 120px);
  padding: 0 16px; /* Espaciado lateral para textos largos */
  gap: 16px; /* Espacio entre título y subtítulo */
  word-break: break-word; /* Permite saltos de línea en textos largos */
}

/* Estado inicial de las tarjetas para la animación (opcional, GSAP lo maneja con fromTo) */
.card-anim {
  opacity: 1;
}
.bouncing--horizontal {
  animation: bounce-horizontal 4s ease-in-out infinite;
}
.bouncing--vertical {
  animation: bounce 4s ease-in-out infinite;
}

@keyframes bounce {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10%);
  }
}
@keyframes bounce-horizontal {
  0%,
  100% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(-10%);
  }
}
</style>
